import posthog from 'posthog-js';
import { track } from '@vercel/analytics';
import { getEnvironmentData } from '../utils/environment';
import { analyticsOptOut } from '../utils/privacy';

export const trackSignIn = (method) => {
  if (analyticsOptOut.hasOptedOut()) return;
  
  const eventData = {
    auth_method: method,
    ...getEnvironmentData()
  };

  posthog.capture('sign_in', eventData);
  track('sign_in', eventData);
  
  // Add TikTok tracking
  if (typeof window !== 'undefined' && window.ttq) {
    window.ttq.track('CompleteRegistration', {
      content_name: 'sign_in',
      content_type: 'product',
      content_id: 'user_authentication'
    });
  }
}; 